export const parseSearch = (search) => {
	return search.replace("?", "").split("&").reduce((acc, item) => {
		const keyVal = item.split("=");
		return Object.assign({}, acc, {
			[keyVal[0]]: keyVal[1]
		});
	}, {});
}
